import { render, staticRenderFns } from "./ShowMoreContent.vue?vue&type=template&id=1fa8b312&scoped=true&lang=pug&"
import script from "./ShowMoreContent.vue?vue&type=script&lang=ts&"
export * from "./ShowMoreContent.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMoreContent.vue?vue&type=style&index=0&id=1fa8b312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8b312",
  null
  
)

export default component.exports